module.exports = __webpack_public_path__ + "static/media/heroBack9.6fa81686.svg";